export default __webpack_public_path__ + "static/media/Jason Khuu - Co-Chair.f3a4cbb9.jpg";